module.exports = __webpack_public_path__ + "static/media/cvs-icon-error.62ca758c.svg";